import { DIRECTORY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export * from './lastChangesFilterConstat';
export * from './IspmTabs';

export const AZURE_ENVIRONMENT = DIRECTORY_TYPES.ad.key;
